import request from 'sb-request'


const unsubscribe = (email) =>
  request.post('rest/email/unsubscribeEmail', {
    body: {
      email,
    },
    formData: true,
  })


export default {
  unsubscribe,
}
